import { zhHans } from 'vuetify/lib/locale'

export default {
	...zhHans,
	loading: '加载中...',
	web: {
		index: {
			login: "登录",
			sigupForFree: "免费注册"
		},
		signin: {
			email: "请输入邮箱",
			password: "请输入密码"
		},
		signup: {
			email: "请输入邮箱",
			password: "请输入密码（8-20位）",
			repassword: "确认输入密码"
		},
		rules: {
			emailCount: "长度不少于5位数",
			passwordCount: "长度在8到20位数",
		},
		forgetpassword: {
			email: "您的邮箱",
			code: "验证码"
		},
		reset: {
			oldPassword: "输入你的旧密码",
			newPassword: "输入你的新密码"
		}
	},
	common: {
		close: "关闭",
		save: "保存",
		bye: "再见",
		cancel: "取消",
		sure: "确定",
		back: "返回",
		refresh: "刷新",
		update: "更新",
		later: "以后再说",
		add: "添加",
		clear: "清空",
		inDevelopment: "正在开发",
		items: "项",
		retry: "全部重试",
		unopened: "暂未开放",
		traffic: "配额",
		dayUnit: "{0}天",
		hourUnit: "{0}时",
		minUnit: "{0}分",
		secUnit: "{0}秒"
	},
	home: {
		myDrives: "云列表",
		transfer: "跨云传输",
		sync: "跨云同步",
		myTasks: "任务列表",
		gift: "订阅",
		resource: "友情链接"
	},
	cloud: {
		new: "云存储",
		emptuyCloudList: "云盘列表空空如也",
		emptuyList: "空空如也",
		newFolder: "新建文件夹",
		emptyFolder: "这个文件夹是空的.",
		searchItem: "搜索当前目录",
		noMatch: "没有找到匹配项",
		invalidTip:"已失效，请更新授权",
		oauthInvalid:"该云盘已过期，请更新授权信息",
		refresh: "刷新容量",
		update: "修改名称",
		delete: "解除授权并删除",
		reloadAuth: "更新授权",
		deletingCloud: "解除授权并删除",
		deleteTip: "如果该云盘有任务正在进行中, 移除云盘将会停止并删除与该云盘相关的所有任务, 确定要继续移除吗？",
		addSuccessTip: "云盘授权成功",
		addExistTip: "云盘授权已刷新",
		addFailTip: "云盘授权失败，或联系客服",
		addSuccess: "云盘添加成功, 请回到界面并刷新云盘列表",
		addExplain: "您可以在以下以开放的云盘列表中点击进行授权登录，点击后将弹出的第三方授权登录页面或跳转到第三方官网授权。",
		endExplain: "未来我们将会支持更多的云盘类型，如有您有希望尽快增加的云盘，请通过留言板告诉我们~感谢支持",
		baidu: "百度网盘",
		chinamobile: "中国移动云盘",
		drive123: "123云盘",
		webdav: "WebDav",
		tencent: "腾讯微云",
		ftp: "FTP",
		jianguoyun: "坚果云",
		drive115: "115网盘",
		thunder: "迅雷云盘",
		wps: "WPS文档",
		ai360:"360AI云盘",
		drive189:"天翼云盘",
		quark: "夸克网盘",
		guangya:"光鸭云盘",
		aliyun: "阿里云盘",
		onedrive: "微软云盘",
		googleDrive: "谷歌云盘",
		dropbox: "Dropbox",
		future: "在未来，我们将开发和支持更多的第三方云盘产品，如果你有想要添加的云盘类型，你可以通过电子邮件告诉我们，后续开放：",
		explorer: {
			myFiles: "根目录",
			name: "名称",
			size: "大小",
			updateTime: "更新时间",
			open: "打开",
			refresh: "刷新",
			delete: "删除",
			preview: "预览",
			rename: "重命名",
			mkdir: "新建文件夹",
			download: "下载",
			upload: "上传",
			search: "搜索",
			copyTo: "传输到",
			moveTo: "移动到",
			site: "跳转官网",

		},
		file: {
			pic: "图片",
			vedio: "视频",
			audio: "音频",
			book: "书籍"
		}
	},
	task: {
		new: "任务",
		title: "任务列表",
		newTask: "新建任务",
		deleteEmpty: "清空列表",
		empty: "任务列表是空的",
		restart: "重启",
		continue: "续传",
		resume: "恢复",
		delete: "删除",
		completed: "文件及文件夹成功率",
		status: {
			running: "运行中",
			waiting: "等待",
			success: "成功",
			failure: "失败",
			lessSuccess: "部分成功",
			mostSuccess: "大部分成功",
			cancel: "取消",
			pause:"暂停",
			recover:"继续",
			unkown: "未知"
		},
		delTitle: "删除任务",
		delTip: "确定要删除该任务吗？",
		itemsSelected: "项被选中",
		sourceNotSelect: "未选择传输源",
		destinationNotSelect: "未选择传输目的地",
		createTip: "云端传输，无需在线，随时随地可登录查看.",
		syncCreateTip: "云端同步，当前默认同步间隔为1天"
	},
	transfer: {
		desc:"该功能支持将A云存储的文件/目录直接传输到B云存储的目录中，整个过程在云端离线运行。",
		addNewCloud: "添加云存储",
		source: "选择来源",
		baiduPath: "/apps/QianClouds",
		baiduOldPath:"/apps/小迈千云",
		baiduRoot: "只能选择\" /我的应用数据/QianClouds \"文件夹及子项",
		thunderLimit: "迅雷云盘暂不支持作为来源",
		destination: "选择目标",
		setting: "设置",
		chipLable: "后缀名如: mp4",
		filterTip: "文件类型过滤器允许你设置自己的过滤规则,包含或者排除设置的选项,系统将根据文件名称的后缀来确定,您可以输入文件类型,如zip、jpg:",
		include: "包含下列文件",
		exclude: "排除下列文件",
		conflictTile: "文件冲突策略",
		taskName: "任务名称",
		cloudTips: "来源和目标单击名称可以进入云盘或文件夹",
		sendEmail: "任务完成后将结果发送到邮件",
		createNow: "开始传输",
		createSync: "开始同步",
		inLine: "该任务正在排队",
		calculating: "正在计算",
		timeRemaining: "估算时间",
		rateTip: "非SVIP下载通常会受官方权益限制，在传输小文件时，由于文件较小，速度看起来也会较慢哦",
		shortSpeed:"",
		folder: "文件夹",
		file: "文件",
		size: "大小",
		skipped: "已跳过",
		failed: "已失败",
		stopTitle: "停止任务",
		stopTip: "是否要停止当前正在运行的任务？",
		stop: "停止",
		cancel: "取消",
		loading: "加载中...",
		from: "来源",
		to: "目标",
		total: "共",
		items: "项",
		stoppingTask: "正在停止任务",
		taskSetting: "任务设置",
		fileConfict: "文件冲突策略",
		confictTip: "在云盘数据传输过程中,若发生文件冲突,将采取您在下列中所选中的策略来处理。",
		notificationEmail: "通知邮件",
		notificationPhoneTip: "请填写您的手机号码",
		notificationEmailTip: "请填写您的邮箱地址",
		time: "时间",
		avgRate: "平均速度",
		startTime: "开始时间",
		endTime: "结束时间",
		failDetails: "错误详情",
		FailDetails: "错误列表",
		path: "路径",
		cause: "原因",
		conflict: {
			skip: "文件已存在时，跳过该文件",
			rename: "文件已存在时，重命名文件",
			replace: "文件已存在时，覆盖原文件",
		},
	},
	sync: {
		desc:"该功能支持将A云存储的目录与B云存储的目录建立同步关系，定期同步，整个过程在云端离线运行。",
		resumeTitle: "恢复同步",
		resumeTip: "是否立即恢复同步",
		logTitle: "同步日志",
		logEmpty: "暂无日志",
		logStart: "开始时间",
		logEnd: "结束时间",
		logAdd: "新增",
		logDelete: "删除",
		logUpdate: "更新"
	},
	user: {
		vipTipTitle: "技术服务反馈",
		vipNow: "点击反馈",
		vipGroup: "技术反馈",
		vipDesc: "您可以扫描下方微信二维码，可以反馈遇到的问题或系统故障，我们将最快为您响应。",
		messageWant: "在这里留言",
		messageBoardBut: "留言板",
		changeAvatar: "更换头像",
		avatarPreview: "预览",
		avatarUpload: "上传头像",
		avatarUploadClick: "点击上传",
		orderList: "订单记录",
		changePassword: "修改密码",
		resetPassword: "修改密码",
		newPassword: "输入你的新密码",
		reNewPassword: "重复你的新密码",
		checkPassword: "两次密码不一致",
		newPasswordCheck: "密码长度限制在8-20位",
		oldPassword: "输入你的旧密码",
		oldPasswordCheck: "密码长度限制在8-20位",
		passwordLimit: "至少8位长度",
		passwordSuccess: "密码修改成功",
		showPassword: "显示",
		logout: "退出",
		del: "注销账号",
		switchLanguage: "切换语言",
		langCn: "简体中文",
		langEn: "English",
		connectUs: "提交工单",
		start: "开始",
		feedback: "问题反馈",
		passwordCheck: "密码长度限制在8-20位",
		unlimited: "无限",
		sessionExpired: "登录会话已过期，请重新登录",
		feedbackDescribe: "亲爱的用户，非常感谢您使用我们的产品，如果在使用过程中出现问题，您可以反馈到以下邮箱，我们将在24小时内处理并回复您。在邮件中，您可以带来您的账号、问题详情、配合操作步骤或图片、视频等，这有利于帮您更快的定位问题，谢谢!"
	},
	gift: {
		type: {
			MONTHLY: "月度订阅"
		},
		compare: "对比权益",
		pricingTable: "服务套餐",
		subtitle: "您的多云数据资产安全管家 · 专业 · 安全 · 可信赖",
		subtitleDesc:"1TB文件=1TB配额",
		orderDetails: "订单详情",
		describe: {
			dialogTitle: "QianClouds 服务协议与使用须知",
			intro: "请您在订阅前了解我们的服务机制。QianClouds 致力于提供合规、安全的云端数据备份与同步通道：",
			p1Title: "合规安全通道",
			p1Desc: "本产品基于官方API开发，不提供任何绕过官方限速的破解服务。您的实际传输速度和单文件大小上限，取决于您在对应云盘的官方会员权益以及QianClouds的通过权益。",
			p2Title: "按量消耗配额，透明计费",
			p2Desc: "数据传输（上传/下载/同步/备份等）按实际流量 1:1 消耗配额（如传输 1GB 文件，扣除 1GB 配额）。配额包支持随时叠加购买。",
			p3Title: "受官方接口稳定性影响",
			p3Desc: "云存储服务受各平台政策及接口波动影响，偶尔可能出现连接延迟，我们会第一时间跟进适配。",
			expandHint: "查看各云盘详细传输限制对照表",
			detailTitle: "QianClouds 服务说明与计费规则",
			detailIntro: "感谢您选择 QianClouds。为了让您获得最佳的数据备份与同步体验，并保障您的账号安全，请仔细阅读以下服务说明：",
			d1Title: "一、 服务定位与安全机制",
			d1a: "QianClouds 是一款纯云端的多云存储数据资产安全服务平台，通过各云盘官方授权的 API 接口为您提供文件备份、同步与传输服务。",
			d1bTitle: "不破解、不存数据",
			d1b: "我们绝不提供任何绕过云存储官方限制或破解会员权益的服务。QianClouds 仅作为数据传输通道，不私自存储您的任何文件内容，保障您的隐私安全。",
			d1cTitle: "速度与权限规则",
			d1c: "QianClouds 提供传输通道和带宽配额，但具体的下载/上传速度以及单文件大小限制，需遵循您所在云盘的官方规则。若需提升传输速度或解除大文件限制，请前往对应云盘官方购买相关权益。",
			d2Title: "二、 计费与配额消耗规则",
			d2aTitle: "配额消耗逻辑",
			d2a: "在您使用产品的备份、同步、上传或下载等传输功能时，系统将按文件实际大小，1:1 消耗您的数据传输配额。（例如：成功传输一个 5GB 的视频，将扣除 5GB 配额）。",
			d2bTitle: "配额有效期",
			d2b: "所有订阅许可均按年计费。配额包支持重复购买且叠加使用，配额包自购买之日起有效期为 1 年，到期未使用完的配额将自动清零。",
			d2cTitle: "任务重试提示",
			d2c: "如因网络波动或接口异常导致任务失败并自动重试，自动重试不会消耗你的配额，仅当文件传输成功后扣减配额。但为了传输可靠性，建议您在进行大批量数据同步前，先使用少量文件测试通道连通性。",
			d3Title: "三、 各大云盘传输限制对照表",
			d3Note: "为避免因官方规则调整带来的误解，以下为目前各云盘在第三方工具（即本站）调用时的常见限制参考。具体限制以云盘官方最新政策为准。",
			tableNote: "若您遇到提示‘文件过大’或‘限速’，通常是由于云盘官方限制了非会员或第三方调用权限，建议检查您在该云盘的官方会员状态。",
			checkboxLabel: "我已阅读并了解上述服务说明，确认购买",
			orderBrief: "数据传输（传输/同步/上传/下载等）按实际文件大小 1:1 消耗配额，比如成功传输1GB文件，将扣除1GB配额。",
		},
		currentPlan: "当前计划",
		order: "立即订阅",
		vipDocument: "付费权益",
		freeDocument: "免费权益",
		speedDesc:"最高通过速度：指的是在传输过程中,本平台提供的传输峰值带宽，实际速度由源和目标双端账号速度权益、当前传输队列中的文件大小、源和目标双端运营服务器稳定性、网络波动影响等多种因素决定，不提供任何绕过官方权益加速的方式。",
		tabs: {
			combo: "灵活套餐",
			retail: "年付享更多",
		},

		subscriptionTitle: "订阅许可",
		subscriptionDesc: "您的多云数据服务管家，安全、便捷、高效",
		trafficTitle: "扩容配额包",
		trafficDesc: "灵活补充传输配额，与订阅许可叠加使用",
		trafficValid: "配额包有效期 1 年 · 配额可叠加",

		comboDesc: "",
		comboSave: "立省",
		details: {
			a: '1. 套餐提供的速度为多文件常规并发数量下的最大支持速度，实际速度受到云盘官方会员权益、文件大小等影响。',
			b: '2. 无限套餐用户在总使用量超过设计阈值时，后续运行速度会有一定幅度降低。',
			c: '3. 套餐价格及权益可能随运营情况做出调整和变更，最终解释权归本站所有。',
			d: "4. ",
			e: "想了解各套餐的具体权益差异，"
		},
		a: {
			title: {
				size: "30G",
				ext: "",
				sale: "￥0",
				name: "免费体验版",
				number: "2312Free",
				speed: '2MB',
				time:"每月1号",
				badge: "",
				id: "1"
			},
			color: "#9CA3AF",
			content: free()
		},
		b: {
			title: {
				size: "1TB",
				ext: "",
				sale: "￥24.8",
				originalSale: "￥29.8",
				name: "月度基础版",
				number: "1TB-M-26082",
				speed: '15MB',
				time:"1个月",
				badge: "最畅销",
				id: "97"
			},
			color: "#4FA0B0",
			

			content: vip(15)
		},
		c: {
			title: {
				size: "100G",
				ext: "",
				sale: "￥8.8",
				name: "轻量即时版",
				number: "100GB-D-2608",
				speed: '15MB',
				time:"1天",
				badge: "",
				id: "96"
			},
			color: "#62c291",

			content: vip(15)
			
		},
		p: {
			title: {
				size: "无限",
				ext: "",
				sale: "￥998",
				originalSale: "￥1298",
				name: "终身永久版",
				number: "Unlimit-Forever-2609",
				speed: '15MB',
				time:"永久",
				badge: "",
				id: "108"
			},
			color: "#3f5db6",

			content: vip(15, 80, 8, true)
			
		},
		
		d: {
			
			title: {
				size: "无限",
				ext: "",
				sale: "￥128",
				name: "季度轻享版",
				number: "Lite-Unlimit-3M-2608",
				speed: '8MB',
				time:"3个月",
				badge: "",
				id: "100",
				start:"2026-08-24"
			},
			color: "#425794",

			content: vip(8, 20, 4)
			
		},
		h: {
			title: {
				size: "无限",
				ext: "",
				sale: "￥168",
				name: "季度畅享版",
				number: "Unlimit-3M-2510",
				time:"3个月",
				speed: '15MB',
				badge: "最欢迎",
				id: "44"
			},
			color: "#6B4294",
			content: vip(15, 30, 8)
			
		},
	
		j: {
			title: {
				size: "无限",
				ext: "",
				sale: "￥298",
				name: "季度极速版",
				number: "Fast-Unlimit/3Y",
				speed: '30MB',
				time:"3个月",
				badge: "",
				id: "101",
				start:"2026-08-24"
			},
			color: "#947B42",
			content: vip(30, 30, 15)
		},
		k: {
			title: {
				// TODO: 第7个套餐占位配置 — 填入真实参数(size/sale/name/number/speed/time/id/content)
				// 并把 start 改为实际上架日期(当日 00:00 自动展示, 漏斗行恢复 3+3)
				size: "待定",
				ext: "",
				sale: "￥0",
				name: "敬请期待",
				number: "Placeholder-7th",
				speed: '15MB',
				time:"3个月",
				badge: "",
				id: "0",
				start:"2099-01-01"
			},
			color: "#4FB07F",
			content: vip(15)
		},
		m: {
			title: {
				size: "无限",
				ext: "",
				sale: "￥428",
				name: "年度畅享版",
				number: "Unlimit-Y-2608",
				time:"12个月",
				speed: '15MB',
				badge: "最划算",
				id: "94"
			},
			color: "#253c98",
			content: vip(15, 80, 8)
		},
		y: {
			title: {
				size: "12TB",
				ext: "",
				sale: "￥148",
				name: "年度轻量版",
				number: "12TB-Y-2608",
				time:"12个月",
				speed: '8MB',
				badge: "轻量年费",
				id: "102"
			},
			color: "#5E7CE0",
			content: vip(8)
		},
		z: {
			a:"速度定制化",
			b:"功能定制化",
			c:"多任务并行执行",
			d:"带宽通道定制化",
			e:"优化算法适配业务模型",
			f:"快速的专业服务响应",
			g:"为业务模型提供解决方案"
		},
		
		other: {
			a: "1. 所有套餐提供的配额均用于传输、同步、备份、上传、下载等消耗，消耗比例为1：1文件大小，即成功传输1GB文件消耗1GB配额",
			b: "2. 所有云存储不提供任何绕过官方权益的服务，所有服务均依赖用户账号在官方的权益，权益详情以官方说明为准",
			c: "3. 为保障服务运营，服务套餐未来可能视运营情况变化，如套餐变更，老用户可直接申请按原订单价额兑换或补差到当前套餐，感谢支持和鼓励"
		},
		multi: {
			desc: "* 单次订购量有效期为 1 年，多次购买可重复叠加配额。"
		},
	},
	addCloud: {
		clickAuth: "直接点击授权挂载该云存储",
		authTitle: "{0}授权登录",
		scanSuccess: "[扫码成功]",
		qrTip: "我们正在请求获取您的云盘接口操作授权，将会对您的{0}操作获取文件列表、详情、下载、上传、删除、重命名等接口进行访问，同意请扫码登录授权。",
		uc: "UC网盘",
		connect123: "123云盘常规连接",
		devTip123: "前往123官网，开通开发者权益包，开通后123云盘将下发client_id和client_secret以“站内信-消息”形式发送。",
		viewTutorial: "查看教程",
		connect: "接入",
		address: "地址:",
		username: "用户名:",
		secret: "密钥:",
		connectService: "连接服务",
		normalConnect: "常规连接",
		protocol: "协议(I):",
		host: "主机(H):",
		port: "端口(P):",
		loginType: "登录类型(L):",
		user: "用户(U):",
		password: "密码(W):",
		keyFile: "密钥文件(K):",
		chooseFile: "选择文件",
		webdavConnect: "WebDav常规连接",
		serviceAddr: "服务地址:",
		preparing: "正在准备打开授权弹窗，请等待",
		comingSoon: "正在完善，敬请期待",
		limitTitle: "付费功能限制",
		limitVipCloud: "升级到付费套餐即可添加该云盘，或选择其他云盘添加",
		completeInfo: "请完善信息",
		fillToken: "请填写Token",
		reachLimit: "触发添加上限",
		reachLimitDesc: "您已达到云盘添加的个数上限，如您需要添加更多云盘，可以通过下方按钮升级套餐来解锁权益功能，感谢您的支持。",
		publicIpOnly: "只支持公网IP地址",
		tab: {
			dev: "开发者模式",
			webdav: "Webdav"
		},
		ftpType: {
			normal: "正常",
			keyFile: "密钥文件"
		}
	},
	explorer: {
		uploading: "正在上传",
		cancelUpload: "取消上传",
		downloadList: "下载列表",
		deleteFile: "删除文件",
		deleteTip: "确定要删除到回收站吗？",
		serverFail: "服务器连接失败，请重试",
		uploadSuccess: "上传成功",
		oneDownload: "已有1个下载任务",
		over2G: "超过2G请用云盘客户端下载",
		canceled: "已取消",
		noDirPicker: "当前浏览器不支持目录选择功能，请使用Chrome 86+或Edge 86+"
	},
	copyTo: {
		selectDest: "选择目标位置",
		limitTitle: "付费功能限制",
		folderLimit: "免费用户不支持文件夹作为源，请升级订阅或选择单个文件",
		quotaLimit: "当前剩余配额不足以完成任务，请升级订阅或重新选择."
	},
	order: {
		orderNo: "订单号",
		orderNoColon: "订单号: {0}",
		createTimeLabel: "创建时间",
		orderDate: "订购日期",
		records: "订购记录",
		plan: "套餐",
		daysCol: "天数",
		amountYuan: "订单金额（元）",
		statusCol: "状态",
		payPending: "待支付",
		payStatusSuccess: "已成功",
		duration: "时长",
		quotaCapacity: "配额容量",
		includesQuota: "含配额",
		validity: "有效期",
		days: "{0}天",
		forever: "永久",
		lifetime: "终身",
		inclQuota: "(含{0}配额)",
		addonTitle: "加购配额包",
		addonHint: "加购更优惠",
		addonValid: "所有配额包有效期 1 年 · 配额可叠加",
		addonOnly: "加购仅 {0}",
		addonPack: "加购{0} 配额包",
		payAmount: "实付金额",
		save: "立省 ￥{0}",
		serviceTitle: "QianClouds 服务说明",
		viewDetails: "查看详情",
		wechatPay: "微信支付",
		alipayPay: "支付宝支付",
		encourage: "您的支持是对我们最大的鼓励，让我们为您创造更好的产品！",
		wechatScanPay: "微信扫码支付",
		alipayScanPay: "支付宝扫码支付",
		qrGenerating: "正在生成二维码...",
		payDone: "支付成功",
		payUnfinished: "支付未完成",
		scanned: "已扫码",
		confirmOnPhone: "请在手机上确认付款",
		scannedWaiting: "已扫码，等待付款...",
		wechatName: "微信",
		alipayName: "支付宝",
		scanPrefix: "请使用",
		scanSuffix: "扫一扫",
		remain: "剩余 {0}",
		done: "完成",
		downloadQr: "下载二维码",
		payTimeout: "支付超时，请重新发起支付",
		wechatNotReady: "微信支付正在开发中，请使用支付宝支付",
		openInWechat: "请在微信中打开进行支付",
		h5Unavailable: "H5支付不可用，请使用扫码支付",
		discountCodeInvalid: "请输入8位有效折扣码",
		invalidOrderNo: "无效的订单号",
		alreadyDiscounted: "已经是折后价格",
		verifySuccess: "核验成功",
		limitTable: {
			platform: "云盘平台",
			sizeLimit: "单文件大小限制（第三方API）",
			speedNote: "传输速度影响说明"
		},
		limit: {
			aliPlatform: "阿里云盘",
			aliLimit: "受官方第三方权益包限制",
			aliNote: "需在阿里云盘官方开通第三方应用流量包",
			p123Platform: "123云盘",
			p123Limit: "官方会员上限 (10GB)",
			p123Note: "受您 123云盘 官方会员等级影响",
			baiduPlatform: "百度网盘",
			baiduLimit: "官方SVIP上限 (20GB)",
			baiduNote: "受您 百度网盘 官方SVIP等级影响",
			p115Platform: "115网盘",
			qcLimit: "受 QianClouds 订阅权益限制",
			p115Note: "受115官方权益及本站通过权益影响",
			quarkPlatform: "夸克网盘",
			quarkNote: "受夸克官方权益及本站通过权益影响",
			xunleiPlatform: "迅雷网盘",
			xunleiNote: "受迅雷官方权益及本站通过权益影响",
			oneDrivePlatform: "OneDrive",
			odNote: "受Onedrive官方权益及本站通过权益影响",
			guangyaPlatform: "光鸭",
			guangyaNote: "受光鸭官方权益及本站通过权益影响"
		}
	},
	mineHome: {
		slogan: "让多云数据更安全、更自由",
		needHelp: "需要帮助？",
		wechatContact: "微信联系",
		wechatService: "微信客服",
		wechatServiceTip: "扫码添加微信客服，获取专属服务",
		messagePlaceholder: "如需帮助，请留下联系方式...",
		messageEmpty: "您还没有告诉我任何问题哦",
		messageSuccess: "留言成功",
		normalUser: "普通用户权益",
		expireAt: "{0} 到期",
		paidQuota: "付费配额",
		freeQuota: "免费配额",
		addonQuota: "扩容配额",
		quotaUsedUp: "流量已用完 · {0} 到期",
		upgrade: "升级订阅",
		goAuth: "去授权",
		storageUnknown: "空间未知",
		inviteTitle: "邀请好友注册",
		inviteDesc: "每月最高可攒5TB",
		renamePlaceholder: "请输入名称",
		confirm: "确认",
		lifetimeUnlimited: "终身无限",
		vipMember: "订阅会员",
		vipBenefit: "订阅权益",
	},
	profile: {
		title: "个人信息",
		nickname: "昵称",
		edit: "修改",
		newNickname: "输入新昵称",
		phone: "手机号",
		unbound: "未绑定",
		bound: "已绑定",
		changeBind: "换绑",
		goBind: "去绑定",
		wechat: "微信",
		loginMethodsTip: "支持手机号+验证码/手机号+密码/账号+密码/微信等多种方式登录",
		wechatBindTitle: "微信绑定",
		wechatScanTip: "请使用微信扫一扫完成绑定",
		nicknameEmpty: "昵称不能为空",
		nicknameSuccess: "昵称修改成功",
		required: "必填.",
		delReasonTip: "向我吐槽...",
		delReasonRequired: "吐槽一下吧",
		delBye: "感谢支持！Bye",
	},
	wechatResult: {
		success: "微信绑定成功",
		fail: "微信绑定失败",
		successDesc: "此后可直接微信扫码登录本账号",
		occupiedDesc: "该微信已绑定其他账号，不可重复绑定",
		expiredDesc: "二维码已过期，请回到个人信息重新发起绑定",
		failDesc: "绑定异常，请回到个人信息重新发起绑定",
		back: "返回控制台",
	},
	mpAuth: {
		success: "云存储授权成功",
		fail: "云存储授权失败",
		successDesc: "请回到微信小程序，云存储列表将自动更新",
		failDesc: "请回到微信小程序重新发起授权",
	},
	transferList: {
		progress: "进度",
		lessThan: "小于{0}",
		sourceRateTip: "受源云盘官方非VIP权益影响，下载速度可能较慢哦~",
		highSpeedQuota: "高速配额",
		continueSpeedup: "继续加速",
		skip: "跳过",
		tooFast: "请勿点击过快",
		speedupDesc: "升级套餐畅享云端高速通道，24小时不间断，便捷省心.",
		quotaDesc: "当前配额已不足，请升级订阅享受更多权益.",
	},
	transferDetails: {
		skip: "跳过",
		skipCount: "{0} 个",
		view: "查看({0})",
		encrypted: "加密传输中:",
		paused: "已暂停",
		calculating: "正在计算...",
		instant: "秒传",
		waiting: "等待中",
	},
	buildTransfer: {
		fullBackup: "全量备份",
		tabFile: "文件",
		tabFilter: "过滤",
		tabMessage: "消息",
	},
	syncList: {
		timerSetting: "定时设置",
		nextFirePrefix: "下次同步时间：",
		remaining: "还有{0}",
		secUnit: "{0}秒",
		hourUnit: "{0}时",
		minUnit: "{0}分",
		hourMin: "{0}时{1}分",
		compareInfo: "({0}项,{1})",
		executeInfo: "({0}%，{1}/s)",
		executeZero: "(0.00%)",
	},
	syncDetails: {
		oneWay: "单向同步",
		twoWay: "双向同步",
		syncDone: "同步完成",
		stopped: "已停止",
		comparing: "比较中",
		deleted: "已删除",
	},
	buildSync: {
		selectSource: '请选择一个源目录',
		setTimerFirst: '请先设置定时计划，选择立即执行或添加定时计划后再创建任务',
		noPlanTip: '您未配置任何定时计划，请点击"定时计划"添加执行计划',
		vipDesc: "该功能为付费用户功能",
	},
	timer: {
		plan: "定时计划",
		planMax: "定时计划（最多{0}个）",
		planName: "计划 {0}",
		executeNow: "立即执行一次",
		executeNowDesc: "创建后立即开始执行任务",
		planOnlyDesc: "仅按定时计划执行",
		day: "每天",
		week: "每周",
		month: "每月",
		weekDay1: "周一",
		weekDay2: "周二",
		weekDay3: "周三",
		weekDay4: "周四",
		weekDay5: "周五",
		weekDay6: "周六",
		weekDay7: "周日",
		monthDay: "日",
		execute: "执行",
		repeat: "重复",
		duplicateTip: "存在相同的定时计划，请修改",
		addPlan: "添加计划",
		emptyPlan: "未配置定时计划",
		timezone: "时区: {0}",
		confirmStart: "确认开始",
	},
	setting: {
		tab: {
			file: "文件",
			filter: "过滤",
			notify: "通知",
		},
		quickTags: "快捷选择",
		notifyTip: "任务完成后，结果将通过下列选择的方式通知您",
		sendEmail: "发送邮箱",
	},
	taskPage: {
		refreshList: "刷新列表",
		transferTab: "传输任务",
		syncTab: "同步任务",
		offlineTip: "任务运行过程中，不需要在线，可以关闭网页或者关机离线哦~",
	},
	giftUi: {
		currentSub: "当前订阅",
		maxSpeed: "最高通过速度",
		limitedTime: "限时 {0}",
		noOrder: "无需订购",
		benefitView: "权益查看",
		benefitTitle: "权益说明",
	},
	giftV2: {
		limitedSub: "有限订阅",
		unlimitedSub: "无限订阅",
		limitedTime: "限时 {0}",
		legacyVipTip: "已有存量订阅的用户可以通过原订阅价格通过补价、折算等方式更换现有订阅，提交工单并留下联系方式即可",
	},
	promo: {
		title: "新用户限时特惠",
		quotaLabel: "传输配额",
		durationLabel: "有效时长",
		remain: "限时剩余 {0}",
		buyNow: "立即抢购",
		later: "稍后再说",
	},
	regGift: {
		claim: "立即收下",
		claimed: "领取成功",
	},
	newUserTraffic: {
		title: "新注册用户福利",
		descPrefix: "平台每个用户可享受",
		freeMonthly: "5GB/月",
		descMid: "的免费流量，如果注册次日登录将再赠送",
		descSuffix: "当月免费流量",
	},
	invite: {
		heroTitle: "邀请好友注册得配额",
		heroSub: "每成功邀请 1 位好友注册，你得 {0}、好友得 {1} 配额奖励，活动长期有效",
		step1Title: "邀请好友注册",
		step1Desc: "复制如下邀请链接，发布到你的社交媒体上，好友通过你的专属链接完成注册即可",
		step2Title: "好友得 {0} 配额",
		step2Desc: "好友通过你的注册链接注册成功后， 好友立即获得{0}扩容配额, 30天内有效",
		step3Title: "你得 {0} 配额",
		step3Desc: "有好友通过你的注册链接完成注册后，你可立即得到{0}配额，1年内有效，可以多人累加，每月最高 {1}，活动长期有效",
		copyLink: "复制注册邀请链接",
		longtermTip: "活动长期有效 · 随时分享",
		monthCount: "本月邀请",
		totalCount: "累计邀请",
		totalGain: "累计获得",
		records: "邀请记录",
		peopleCount: "{0} 人",
		registered: "已注册",
		emptyTitle: "暂无邀请记录",
		emptyDesc: "复制邀请链接，分享给好友开始赚取配额",
		rulesTitle: "活动规则",
		rule1: "好友通过你的邀请链接注册，双方各获得配额",
		rule2: "邀请人每月最多奖励 {0} 人，超出后被邀请人仍可获得奖励",
		rule3: "配额发放至扩容配额包，有效期1年，每月可叠加",
		loadFail: "获取邀请信息失败",
		copied: "已复制",
		shareText: "我在用 QianClouds 管理多个云盘，支持阿里云盘、百度网盘等12种云盘互传，离线传输不占本地带宽。通过我的链接注册，你可得 {0} 免费配额！",
		monthDay: "{0}月{1}日",
		dialogTitle: "邀请好友，双方各自都得到配额",
		inviteCode: "邀请码",
		shareLink: "分享链接",
		copy: "复制",
		monthInvited: "本月已邀请",
		progressCount: "{0} / {1} 人",
		totalQuota: "累计获得配额",
		copyShareText: "一键复制分享文案",
	},
	resource: {
		empty: "暂无资源链接",
		disclaimer: "第三方网站免责声明：本站友情链接均来自第三方网站，内容的准确性、安全性和合法性由第三方网站负责。用户访问第三方网站产生的任何后果与本站无关，请自行判断并承担相应风险。",
		kkgyName: "库库光影",
		kkgyDesc: "一站式网盘资源搜索引擎，聚合百度网盘、夸克网盘、UC网盘、迅雷网盘等主流平台资源。免费搜索电影、资料、软件、游戏等网盘资源链接，帮你快速找到想要的资源，无需多平台重复查找。",
	},
	backup: {
		title: "云盘备份",
		titleSoon: "云盘备份（下个版本开放）",
		a: "1. 支持任何云盘到其他云盘备份，支持一次性备份到多个云盘。",
		b: "2. 每次备份将会生成一个日期版本，支持按不同版本进行还原。",
		c: "3. 支持定时备份计划，自定义备份周期，支持保留最近N次版本功能，自动清理备份空间。",
		d: "4. 支持文件冲突选项、过滤选项、消息通知、流量告警、云盘空间告警等功能。",
		support: "请多赞助，请多多支持。",
	},
	help: {
		title: "提交工单",
		descLabel: "问题描述",
		descPlaceholder: "请详细描述您遇到的问题...",
		descLimit: "字数不超过500",
		uploadLabel: "上传截图（可选）",
		uploadClick: "点击上传图片",
		contactLabel: "联系方式（微信或邮箱）",
		contactPlaceholder: "请输入您的微信号或邮箱",
		submit: "提交工单",
		toastSize: "图片大小不能超过5MB",
		toastDescRequired: "请输入问题描述",
		toastDescLimit: "描述字数不超过500",
		toastContactRequired: "请输入联系方式",
		toastSuccess: "工单提交成功，我们会尽快处理",
		toastFail: "提交失败，请稍后重试",
	},
	robot: {
		name: "小迈",
		newChat: "新对话",
		inputPlaceholder: "输入消息...",
		thinking: "思考中...",
	},
	bind: {
		title: "绑定手机号码",
		phonePlaceholder: "您的手机号码",
		codePlaceholder: "验证码",
		resend: "重新发送({0})",
		sendCode: "发送验证码",
		bound: "已绑定：{0}",
		change: "更换",
		invalidPhone: "无效的手机号",
		codeLength: "6位数验证码",
		invalidPhoneNum: "无效的手机号码",
		invalidCode: "无效的验证码",
		success: "手机号绑定成功",
	},
	preview: {
		zoomOut: "缩小",
		zoomIn: "放大",
		reset: "重置",
		hint: "滚轮缩放 · 拖拽移动 · ESC关闭",
		fallback: "图片预览",
	},
	guide: {
		step1Title: "第一步：添加云盘",
		step1Desc: "选择你需要管理的云盘，点击授权挂载。支持阿里云盘、百度网盘、115网盘等多种云存储服务。",
		step2Title: "第二步：管理你的文件",
		step2Desc: "在这里可以浏览、下载、上传和管理你云盘中的文件。支持新建文件夹、重命名、搜索等操作。",
		step3Title: "第三步：创建跨云传输任务",
		step3Desc: "选择来源文件和目标目录，一键创建跨云传输任务，实现不同云存储之间的文件传输。",
		menuTitle: "文件操作菜单",
		menuDesc: "点击文件或文件夹即可打开此菜单。",
		next: "下一步",
		prev: "上一步",
		done: "完成",
		skip: "跳过",
	},
	http: {
		maintaining: "服务维护中，请几分钟后再试",
		networkError: "网络连接异常",
	},
	taskShow: {
		etc: " 等{0}个",
	},
}
function free() {
	return {
		a: "部分云存储授权",
		b: "云盘在线管理",
		c: "最多2个云盘",
		w: "跨云传输功能",
		d: "仅传输单个文件",
		e: "单文件不超过10G",
		f: "最高2MB/s通过速度",
	}
}

function vip(speed, limit, limitSpeed, forever) {
	let data = {
		a: "全部云存储授权",
		b: "云盘在线管理",
		p: "绑定 10 个云盘",
		o: "任务自动排队",
		c: "跨云传输功能",
		d: "文件夹传输",
		f: "支持100GB单文件传输",
		h: "最高" + speed+"MB/s通过速度",
		k: "文件秒传",
		g: "智能多文件并行",
		w: "跨云同步功能",
		z: "支持天、周、月定时执行",
		y: "提供工单技术支持"
	}
	if(limit){
		data.l = "累计超过" + limit + "TB后降速到" + limitSpeed + "MB/s";
		if(forever){
			data.l = "每年超过" + limit + "TB后降速到" + limitSpeed + "MB/s";
		}
	}
	
	return data
}